import React from "react";

import { DonutChart } from "../charts/DonutChart";
import { ChartLayout, layoutHeight, layoutWidth } from "../charts/chartTheme";

interface EsgPieProps {
    data: any;
    showLegend?: boolean;
    textData?: any;
    textInfo?: string;
    header?: string;
    layout?: ChartLayout;
    style?: React.CSSProperties | undefined;
}

export const EsgPie = ({ header, showLegend, layout, data, textInfo, style }: EsgPieProps): React.ReactElement => {
    const labels = Object.keys(data ?? {});
    const slices = labels.map((label) => ({ label, value: Number(data[label]) }));
    let labelMode: "none" | "percent" | "label+percent" = "percent";
    if (textInfo && String(textInfo).includes("label") && String(textInfo).includes("percent")) labelMode = "label+percent";
    else if (textInfo === "none") labelMode = "none";
    const show = typeof showLegend === "boolean" ? showLegend : layout?.showlegend;

    return (
        <React.Fragment>
            {header ? <h3>{header}</h3> : null}
            <DonutChart
                slices={slices}
                colors={layout?.colorway ?? ["#2186c5", "#43a04c", "#ba46b8", "#009688", "#9e9e9e", "#e5878a"]}
                hole={0.4}
                showLegend={show}
                labelMode={labelMode}
                ariaLabel={header || "ESG"}
                height={layoutHeight(layout, 320)}
                width={layoutWidth(layout)}
                style={style}
            />
        </React.Fragment>
    );
};
